const STORAGE_KEY = "scannerType";
const VALID = ["camera", "qrscanner"];

const initialScannerType = () => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (VALID.includes(stored)) return stored;
    const envDefault = process.env.VUE_APP_SCANNER_TYPE;
    return VALID.includes(envDefault) ? envDefault : "camera";
};

const state = {
    scannerType: initialScannerType(),
};

const getters = {
    scannerType: (state) => state.scannerType,
    isQrScanner: (state) => state.scannerType === "qrscanner",
};

const mutations = {
    setScannerType(state, value) {
        const next = VALID.includes(value) ? value : "camera";
        state.scannerType = next;
        localStorage.setItem(STORAGE_KEY, next);
    },
};

const actions = {
    setScannerType({ commit }, value) {
        commit("setScannerType", value);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
